export default () => ({
    shipments: [],
    isFetching: false,
    payment: null,
    hasError: false,
    error: null,
    isDeleting: false,
    isUpdating: false,
    isCreating: false,
    itemWithoutShipment: {
        error: null,
        item: null,
        buyerContactDetails: null,
        isFetching: false
    },
    nonIntegrated: {
        open: false,
        provider: null,
        isUpdating: false,
        markedAsBooked: false,
        markedAsShipped: false,
        hasError: false
    },
    shipping: {
        shippingOptions: [],
        isShippingFetching: false,
        hasShippingError: false
    }
});
